import Footer from "components/Footer/Footer";
import React from "react";
import ListClinic from "../../views/clinic/ListClinic";
function Clinic() {
  return <ListClinic />;
}

export default Clinic;
